import React from 'react';
import PropTypes from 'prop-types';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Slide from '@material-ui/core/Slide';

import {
  toastContainer,
  messageContainer,
  toastContent,
  Message,
  EmojiContainer,
  DismissButton,
} from './Toast.styled';

const containerClasses = {
  root: 'toastRoot',
};

const contentClasses = {
  message: 'toastMessage',
  action: 'toastAction',
};

const Toast = ({ open, onClose, emoji, message, autoHideDuration }) => (
  <Snackbar
    classes={containerClasses}
    className={toastContainer}
    open={open}
    onClose={onClose}
    TransitionComponent={Slide}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    autoHideDuration={autoHideDuration}
  >
    <SnackbarContent
      classes={contentClasses}
      className={toastContent}
      message={
        <Message>
          {emoji && <EmojiContainer>{emoji}</EmojiContainer>}
          <span className={messageContainer}>{message}</span>
        </Message>
      }
      action={
        <DismissButton key="close" aria-label="dismiss" onClick={onClose}>
          <span>Dismiss</span>
        </DismissButton>
      }
    />
  </Snackbar>
);

Toast.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  emoji: PropTypes.string,
  message: PropTypes.string.isRequired,
  autoHideDuration: PropTypes.number,
};

Toast.defaultProps = {
  emoji: '',
  autoHideDuration: 5000,
};

export default Toast;
